export default "__VITE_ASSET__38ed4403__"